import { type OrderDetails } from "@koala/sdk";
import { type ConnectedProps, connect } from "react-redux";
import HeartIcon from "@/components/uielements/heartIcon";
import { BASKET_ORDER_KEYS, K_ANALYTICS_EVENTS } from "@/constants/events";
import meActions from "@/redux/me/actions";
import { type RootState } from "@/types/app";
import { fireGenericOrderEventsHandler } from "@/utils/events";
import { fireGaEvent, gaActions, gaCats } from "@/utils/googleAnalytics";
import { isOrderFavorited } from "@/utils/orders";

interface Props extends ReduxProps {
  order: OrderDetails;
  eventDetail: string;
}

const _FavoriteIcon = ({
  order,
  eventDetail,
  addFavoriteOrder,
  removeFavoriteOrder,
  meFavoriteOrders,
}: Props) => {
  const toggleFavoriteOrder = (order: OrderDetails, favorite: boolean) => {
    let eventLabel = K_ANALYTICS_EVENTS.ORDER_FAVORITED;

    if (favorite) {
      addFavoriteOrder(order.id);
      fireGaEvent(gaCats.account, gaActions.orderFavorited);
    } else {
      removeFavoriteOrder(order.id);
      fireGaEvent(gaCats.account, gaActions.orderUnfavorited);
      eventLabel = K_ANALYTICS_EVENTS.ORDER_UNFAVORITED;
    }

    fireGenericOrderEventsHandler(
      eventLabel,
      /** @TODO fix this. */
      // @ts-expect-error type mismatch in location.id (string <> number)
      order.order_data.basket,
      order,
      [
        BASKET_ORDER_KEYS.TRANSACTION,
        BASKET_ORDER_KEYS.ORDER,
        BASKET_ORDER_KEYS.BASKET_PRODUCTS,
      ],
      eventDetail
    );
  };

  return (
    <HeartIcon
      favorites={true}
      active={isOrderFavorited(order.id, meFavoriteOrders)}
      onClick={(favorite: boolean) => toggleFavoriteOrder(order, favorite)}
      label={`Click to favorite order # ${order.id}`}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  meFavoriteOrders: state.app.me.favoriteOrders,
});

const mapDispatchToProps = {
  addFavoriteOrder: meActions.addFavoriteOrder,
  removeFavoriteOrder: meActions.removeFavoriteOrder,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export const FavoriteIcon = connector(_FavoriteIcon);
